export const queryKeys = {
  /*
   * The betAccount key is used to cache the bet account details outside of the @mobi/account package.
   * It uses the cache from the old state management. This cannot be invalidated wihout access to @core.
   */
  betAccount: 'bet-account',
  /*
   * The depositBetAccount key is used to cache the bet account details inside of the @mobi/account package.
   */
  depositBetAccount: 'deposit/bet-account',
  depositAddCard: 'deposit/add-card',
  depositInitialData: `deposit/initial-data`,
  depositGeneratePayId: 'deposit/generate-payid',
  depositGetBsbDetails: 'deposit/get-bsb-details',
  withdrawDetails: 'withdraw/withdraw-details',
  withdrawCreateZeptoContact: 'withdraw/create-zepto-contact',
  withdrawDeleteZeptoContact: 'withdraw/delete-zepto-contact',
  accountSendOtp: 'account/send-otp',
  accountCountryList: 'account/country-list',
  accountUserContactDetails: 'account/user-contact-details',
  signupPrecommitment: 'signup/precommitment',
  signupCreateWageringBetAccount: 'signup/wagering-account',
  signupCreateSignUpApplication: 'signup/application',
  signupVerifyDriversLicence: 'signup/drivers-licence',
  signupVerifyMedicare: 'signup/medicare',
  signupVerifyPassport: 'signup/passport',
}

export const toastIds = {
  pendingWithdrawal: 'withdrawal-pending',
}
